import { render, staticRenderFns } from "./TrademarkSearchResponsibleList.vue?vue&type=template&id=015a0880&"
import script from "./TrademarkSearchResponsibleList.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchResponsibleList.vue?vue&type=style&index=0&id=015a0880&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports